<!--
 * @Author: fengxiaojing
 * @Description: 模型浏览
                query {
                  documentId: '',
                  sceneId: '',
                }
-->
<template>
  <div class="h-full position-relative model-doc-preview" v-loading="isShowWaitLayer">
    <image-annotation-new
      v-if="showImageAnnotation"
      :captureProps="captureProps"
      @save="handleAnnotationSave"
      @close="handleAnnotationClose"
    ></image-annotation-new>
    <!-- <div class="model-top fz-28 w-full position-absolute flex-align-center flex-row-center flex">
      <span
        class="position-absolute ell text-center w-full text-40px text-white"
        style="font-size: 40px"
        >WIZ Resource</span
      >
      <div class="top-parent-left h-full position-relative">
        <div
          class="top-left position-absolute"
          :style="{ left: `${backgroundOffsetX * -1}px` }"
        ></div>
        <span class="anchor-pos text-white text-14px pl-5px position-absolute">{{
          `X:${anchorPos[0]} Y:${anchorPos[1]} Z:${anchorPos[2]}`
        }}</span>
      </div>
      <div class="top-mid"></div>
      <div class="top-parent-right h-full position-relative">
        <div
          class="top-right position-absolute"
          :style="{ right: `${backgroundOffsetX * -1}px` }"
        ></div>
        <div
          class="setting-model flex-row-end flex-align-center pr-10px flex"
        >
          <el-tooltip effect="dark" content="设置" placement="top" :open-delay="1000">
            <i class="iconfont icon-app-set text-18px cur-pointer" @click="handlePlayerSetting"></i>
          </el-tooltip>
        </div>
      </div>
    </div> -->
    <!-- player设置 -->
    <PlayerSetting
      v-if="showPlayerSetting"
      ref="playerSetting"
      :player="mainPlayer"
      @closeSetting="closeSetting"
    ></PlayerSetting>
    <el-row class="h-full">
      <el-col v-if="spanLeft !== 0" :span="spanLeft" class="h-full position-relative">
        <model-view
          v-if="mainFileType === 'pr' || mainFileType === 'scene'"
          ref="modelView"
          class="bg-white"
          style="overflow: hidden"
          playerEngineId="engineId"
          :code="currentCode"
          :modelProps="modelProps"
          :showDocComponent="showDocComponent"
          :docHeight="docHeight"
          :modelParams="modelList"
          :modelName="currentDocumentId"
          :basicTabBar="basicTabBar"
          :codeChangeType="codeChangeType"
          :businessTabBar="businessTabBar"
          :businessTabInfo="businessTabInfo"
          :showPlayerSysSetting="showPlayerSetting"
          :currentCreateNode="currentCreateNode"
          :currentEditMoment="currentEditMoment"
          :showCloseScreen="showCloseScreen"
          @closeSystemSetting="closeSetting"
          @annotationClick="annotationClick"
          @sendBasicComponents="sendBasicComponents"
          @sendPlayer="sendPlayer"
          @modelClick="modelClick"
          @tagsBusinessClick="tagsBusinessClick(arguments, 'main')"
          @LoadedAllModel="LoadedAllModel"
          @handleNodeClick="handleNodeClick"
          @modifyNodeEnd="modifyNodeEnd"
          @updateModelNode="updateModelNode"
        >
          <doc-relational
            ref="docRelational"
            :heightObj="docHeight"
            :modelParams="modelList"
            :documentId="currentDocumentId"
            @getModelData="getModelData"
            @splitScreen="splitScreen"
            @showDoc="showDoc"
            @changeModelData="changeModelData"
            :tagCode="docModelCode"
            :standardId="standardId"
            :classId="classId"
          ></doc-relational>
          <bit-relational
            ref="bitRelational"
            :heightObj="bitHeight"
            :bitRelationalData="bitRelationalData"
            :tagCode="bitModelCode"
            :tagId="tagId"
            :isTag="isTag"
            :fileId="currentModel.fileId"
            @currentCodeChange="currentCodeChange"
            @getModelData="getModelData"
            @setObjectNode="setObjectNode"
            @splitScreen="splitScreen"
            @showBit="showBit"
          ></bit-relational>
          <ModelEditTool
            v-if="showModelEditTool"
            :tagCode="currentCode"
            :player="mainPlayer"
            :height="editToolHeight"
            :top="editToolTop"
            :currentModel="currentModel"
            :documentId="currentModel.documentId"
            :currentNodeData="currentEngineerNode"
            :watchNodeModify="watchNodeModifyTiming"
            @closeComponent="closeBusinessComponent"
            @updateEditTree="updateEditTree"
          ></ModelEditTool>
          <!-- 业务组件弹框 -->
          <DialogTabBar
            :top="componentTop"
            direction="right"
            :currentCom="showBusinessComponents"
            :dialogList="openDialogList"
            @switchDialog="switchDialog"
            v-if="showBusinessDialog"
          ></DialogTabBar>
          <keep-alive
            :include="
              _.map(openDialogList, (item) => {
                return item.val
              }).join(',')
            "
          >
            <component
              :isShowBasicCom="!!basicComponents || showDocComponent"
              :is="showBusinessComponents"
              :tagCode="currentCode"
              :player="mainPlayer"
              :loadedModel="loadedModel"
              :height="componentHeight"
              :top="componentTop"
              :allConvertNodeList="allConvertNodeList"
              :currentModel="currentModel"
              :sceneOpenType="modelProps.sceneOpenType"
              :documentId="currentModel.documentId"
              :currentNodeData="currentEngineerNode"
              :watchNodeModify="watchNodeModifyTiming"
              v-if="showBusinessDialog"
              @splitScreen="splitScreen"
              @currentCodeChange="currentCodeChange"
              @showMarker="showMarker(arguments, 'main')"
              @closeComponent="closeBusinessComponent"
              @updateEditTree="updateEditTree"
            ></component>
          </keep-alive>
          <MeasurePoint
            v-if="showMeasurePoint"
            :player="mainPlayer"
            :isShowBasicCom="!!basicComponents || showDocComponent"
          ></MeasurePoint>
          <DeviceDetail
            v-if="showDeviceDetail"
            :player="mainPlayer"
            :fileId="currentModel.fileId"
            :isShowBasicCom="!!basicComponents || showDocComponent"
          ></DeviceDetail>
          <AlarmInfo
            v-if="showAlarmInfo"
            :player="mainPlayer"
            :isShowBasicCom="!!basicComponents || showDocComponent"
            @closeComponent="closeBusinessComponent"
          ></AlarmInfo>
          <EquipmentInfo
            v-if="showEquipmentInfo"
            :player="mainPlayer"
            :isShowBasicCom="!!basicComponents || showDocComponent"
            @closeComponent="closeBusinessComponent"
          ></EquipmentInfo>
          <PipeFlowDirection
            ref="PipeFlowDirection"
            :documentId="currentModel.documentId"
            v-if="showPipeFlowDirection"
            :player="mainPlayer"
          >
          </PipeFlowDirection>
          <LedgerRelated
            ref="LedgerRelated"
            v-if="showLedgerRelated"
            :comPlayer="mainPlayer"
          ></LedgerRelated>
        </model-view>
        <file-preview
          v-else-if="fileTypeList.includes(mainFileType)"
          :fileProps="fileMainProps"
          :imgType="imgTypeList"
          :tagCode="currentCode"
          @loadFile="loadFile"
          @svgClick="svgClick"
        ></file-preview>
        <!-- 截图等待时的透明图层 -->
        <!-- <div class="h-full w-full wait_layer" v-if="isShowWaitLayer">
          <div class="loading-container">
            <i class="el-icon-loading"></i>
            <div>正在初始化...</div>
          </div>
        </div> -->
        <!-- 截图编辑时的蒙层 -->
        <!-- <edit-View
          v-if="showMainEditPhoto"
          :EditViewProps="MainEditViewProps"
          @hideEditView="hideMainEditView"
        ></edit-View> -->
      </el-col>
      <el-col v-if="spanRight !== 0" :span="spanRight" class="h-full position-relative">
        <model-view
          v-if="splitFileType === 'pr' || splitFileType === 'scene'"
          ref="splitModelView"
          class="bg-white"
          :modelParams="modelSplitList"
          :modelProps="modelSplitProps"
          :showCloseScreen="showCloseScreen"
          :code="currentCode"
          :codeChangeType="codeChangeType"
          playerEngineId="splitEngineId"
          :modelName="currentSplitDocumentId"
          :basicTabBar="basicTabBar"
          @modelClick="modelClick"
          @updateModelNode="updateModelNode"
        ></model-view>
        <file-preview
          v-else-if="fileTypeList.includes(splitFileType)"
          :imgType="imgTypeList"
          :fileProps="fileSplitProps"
          :tagCode="currentCode"
          @loadFile="loadFile"
          @svgClick="svgClick"
          @captureImage="captureImage"
          @showMarker="showMarker(arguments, 'split')"
        ></file-preview>
        <!-- 截图等待时的透明图层 -->
        <div class="h-full w-full wait_layer" v-if="isShowWaitLayer"></div>
        <!-- 截图编辑时的蒙层 -->
        <!-- <edit-View
          v-if="showSplitEditPhoto"
          :EditViewProps="SplitEditViewProps"
          @hideEditView="hideSplitEditView"
        ></edit-View> -->
      </el-col>
    </el-row>
    <!-- 收缩分屏按钮 -->
    <div
      v-if="showCloseScreen"
      class="
        w-30px
        h-30px
        absolute
        top-0
        right-0
        text-center
        cursor-pointer
        leading-30px
        bg-[#e41b1b]
      "
      @click="showCloseScreen = !showCloseScreen"
    >
      <i class="icon el-icon-close text-18px text-white"></i>
    </div>
    <!-- <el-tooltip
      v-if="splitFileType"
      :content="showCloseScreen ? '缩起分屏' : '展开分屏'"
      placement="top"
      :open-delay="1000"
    >
      <span
        class="iconfont icon-line-circleQuit text-color-blue fz-16 position-absolute split_icon"
        :style="!showCloseScreen ? 'transform:rotate(180deg)' : ''"
        @click="showCloseScreen = !showCloseScreen"
      ></span>
    </el-tooltip> -->

    <!-- 查看批注列表面板 -->
    <div
      v-if="showAnnotationListDialog"
      class="annotation-list-panel"
      v-loading="isLoadingAnnotations"
    >
      <div class="annotation-list-header">
        <span class="title">批注列表</span>
        <i class="el-icon-close close-icon" @click="closeAnnotationList"></i>
      </div>
      <div class="annotation-list">
        <el-empty v-if="!annotationLists.length" description="暂无批注记录"></el-empty>
        <div v-else class="annotation-items">
          <div v-for="(item, index) in annotationLists" :key="index" class="annotation-item">
            <div class="annotation-content">
              <!-- 添加删除按钮 -->
              <div
                class="delete-annotation-btn"
                @click.stop="handleDeleteAnnotation(item)"
                title="删除批注"
              >
                <i class="el-icon-delete"></i>
              </div>
              <el-image
                :preview-src-list="
                  item.Annotation ? [`data:image/jpeg;base64,${item.Annotation}`] : []
                "
                :src="`data:image/jpeg;base64,${item.Annotation}`"
                :alt="item.ReviewRecord"
                class="annotation-image"
                fit="contain"
              >
                <template #placeholder>
                  <div class="image-loading">
                    <i class="el-icon-loading"></i>
                    <p>加载中...</p>
                  </div>
                </template>
                <template #error>
                  <div class="image-error">
                    <i class="el-icon-picture-outline"></i>
                    <p>图片加载失败</p>
                  </div>
                </template>
              </el-image>
            </div>
            <div class="annotation-header">
              <span class="annotation-title">{{ item.ReviewRecord }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AccessControlSecurity from '@/services/baoChang/accessControlSecurity'
import DocumentManagementService from '@/services/documentManagement'
import SceneCenter from '@/services/sceneCenter'
import addService from '@/services/addManageService'
import ApiMixinModelCenter from '@/assets/js/api/modelCenter'
import { initPlayer } from '@/views/baochang/documentBrowseDemo/js/drawUtil'
import docViewTabBarTactics from './js/docViewTabBarTactics'
import ImageAnnotationNew from '../../components/imageAnnotationNew'
import EventBus from './components/js/EventBus'

const ModelView = () => {
  return import('../../components/model/ModelView')
}
const FilePreview = () => {
  return import('./components/FilePreview')
}
const DocRelational = () => {
  return import('./components/DocRelational')
}
const BitRelational = () => {
  return import('./components/BitRelational')
}
const DialogTabBar = () => {
  return import('@/components/model/DialogTabBar')
}
// 业务组件
const RoamPathList = () => {
  return import('./components/businessDialog/RoamPathList')
}
const CableList = () => {
  return import('./components/businessDialog/CableList')
}
const clashList = () => {
  return import('./components/businessDialog/clashList')
}
const ProcessRelational = () => {
  return import('./components/businessDialog/ProcessRelational')
}
const PointSetting = () => {
  return import('./components/businessDialog/PointSetting')
}
const MonitorList = () => {
  return import('./components/businessDialog/MonitorList')
}
const ConfigureManage = () => {
  return import('./components/businessDialog/ConfigureManage')
}
const EquipmentInfo = () => {
  return import('./components/businessDialog/equipment/EquipmentInfo')
}
const MarkerList = () => {
  return import('./components/businessDialog/MarkerList')
}
const LedgerRelated = () => {
  return import('@/views/baochang/documentBrowseDemo/components/LedgerRelated')
}
// 二三维标记截图组件
// const EditView = () => {
//   return import('./components/businessDialog/photoEdit/EditView')
// }
// 电子围栏
const FenceDataList = () => {
  return import('./components/businessDialog/FenceDataList')
}
// 关联测点
const BindMeasurePoint = () => {
  return import('./components/businessDialog/BindMeasurePoint')
}
// 测点历史数据
const MeasurePoint = () => {
  return import('./components/businessDialog/MeasurePoint')
}
// 报警信息
const AlarmInfo = () => {
  return import('./components/businessDialog/alarm/AlarmInfo')
}
// 门禁详细列表
const AccessControlList = () => {
  return import('./components/businessDialog/AccessControlList')
}
// 安防详细列表
const SecurityList = () => {
  return import('./components/businessDialog/SecurityList')
}
// 新增模型节点
const AddDeviceModel = () => {
  return import('./components/businessDialog/AddDeviceModel')
}
// 二次设备编辑
const SecondaryDeviceEdit = () => {
  return import('./components/businessDialog/SecondaryDeviceEdit')
}
// 模型编辑工具
const ModelEditTool = () => {
  return import('./components/businessDialog/ModelEditTool')
}
// 人员定位
const PersonnalPosition = () => {
  return import('./components/businessDialog/PersonnalPosition')
}
// 绘制电子围栏
const FenceDraw = () => {
  return import('./components/businessDialog/FenceDraw')
}
// player设置
const PlayerSetting = () => {
  return import('@/components/model/dialog/PlayerSetting')
}
// 卷册文档
const VolumeDocuments = () => {
  return import('./components/businessDialog/VolumeDocuments')
}
// 数据监测
const DataMonitoring = () => {
  return import('./components/businessDialog/DataMonitoring')
}
// 设备详情
const DeviceDetail = () => {
  return import('./components/businessDialog/DeviceDetail')
}
// 管道流向组件
const PipeFlowDirection = () => {
  return import('./components/businessDialog/PipeFlowDirection')
}
export default {
  name: 'fileView',
  mixins: [ApiMixinModelCenter],
  components: {
    ImageAnnotationNew,
    ModelView,
    DocRelational,
    BitRelational,
    FilePreview,
    RoamPathList,
    CableList,
    clashList,
    ProcessRelational,
    PointSetting,
    MonitorList,
    FenceDataList,
    DialogTabBar,
    ConfigureManage,
    EquipmentInfo,
    MarkerList,
    BindMeasurePoint,
    MeasurePoint,
    // EditView,
    AlarmInfo,
    PersonnalPosition,
    FenceDraw,
    PlayerSetting,
    AccessControlList,
    SecurityList,
    AddDeviceModel,
    ModelEditTool,
    SecondaryDeviceEdit,
    VolumeDocuments,
    DataMonitoring,
    DeviceDetail,
    PipeFlowDirection,
    LedgerRelated,
  },
  data() {
    return {
      annotationLists: [], // 批注记录
      showAnnotationBtn: false,
      showImageAnnotation: false,
      currentEnv: Wiz.GetModuleConfig('legacy-resource').currentEnv,
      // 二三维截图部分数据
      showMainEditPhoto: false, // 是否显示截图蒙层
      showSplitEditPhoto: false, // 分屏是否显示截图蒙层
      MainEditViewProps: {
        // 主屏截图编辑需要的信息
        imgUrl: '',
        fileLocation: '',
        fileId: '',
        markType: '',
      },
      SplitEditViewProps: {
        // 分屏截图编辑需要的信息
        imgUrl: '',
        fileLocation: '',
        fileId: '',
        markType: '',
      },
      rotationAngle: 180, // 默认旋转角度
      modelSplitProps: {
        defaultModelId: '', // 默认加载的模型id
        sceneOpenType: '', // 加载场景类型
      },
      modelSplitList: [],
      currentSplitDocumentId: '',
      imgTypeList: ['png', 'jpg', 'gig', 'bmp', 'tif'], // 图片类型集合
      // 模型加载相关start
      modelProps: {
        defaultModelId: '', // 默认加载的模型id
        sceneOpenType: '', // 加载场景类型
      },
      modelList: [], // 模型列表
      loadedModel: false, // 模型是否加载完成
      basicTabBar: [
        {
          name: '模型树',
          val: 'ModelTree',
          maxHeight: '40rem',
          minHeight: '40rem',
          iconName: 'icon-line-tree',
          unAllowCoexistCom: [],
        },
        {
          name: '点选',
          val: 'system.Pickup',
          iconName: 'icon-yxr-clickSelect',
          unAllowCoexistCom: [],
        },
        {
          name: '移动',
          val: 'system.Move',
          iconName: 'icon-yxr-move',
          unAllowCoexistCom: [],
          hoverWidth: 200,
          children: [
            {
              name: '移动',
              val: 'system.Move',
              iconName: 'icon-yxr-move',
              unAllowCoexistCom: [],
            },
            {
              name: '旋转',
              val: 'system.Rotate',
              iconName: 'icon-yxr-rotate',
              unAllowCoexistCom: [],
            },
            {
              name: '驻点观察',
              val: 'system.ToolFixedObservation',
              iconName: 'icon-line-patrolInspection',
              unAllowCoexistCom: [],
            },
            {
              name: '缩放',
              val: 'system.Scale',
              iconName: 'icon-yxr-zoom',
              unAllowCoexistCom: [],
            },
            {
              name: '居中',
              val: 'system.PickupCenter',
              iconName: 'icon-yxr-center',
              unAllowCoexistCom: [],
            },
          ],
        },
        {
          name: '隐藏',
          val: 'system.ToolHideModel',
          iconName: 'icon-line-hide',
          hoverWidth: 151,
          unAllowCoexistCom: [],
          children: [
            {
              name: '隐藏',
              val: 'system.ToolHideModel',
              iconName: 'icon-line-hide',
              unAllowCoexistCom: [],
            },
            {
              name: '显示上一个',
              val: 'system.ToolShowModel',
              iconName: 'icon-yxr-showPrevious',
              unAllowCoexistCom: [],
            },
            {
              name: '显示所有已隐藏',
              val: 'system.ToolShowAll',
              iconName: 'icon-yxr-showAllHidden',
              unAllowCoexistCom: [],
            },
            {
              name: '空间交换',
              val: 'system.ToolHideModelSpaceSwap',
              iconName: 'icon-line-refresh',
              unAllowCoexistCom: [],
            },
          ],
        },
        {
          name: '地下开挖',
          val: 'UndergroundClip',
          maxHeight: '43rem',
          minHeight: '35rem',
          iconName: 'icon-yxr-undergroundExcavation',
          unAllowCoexistCom: [],
        },
        {
          name: '全局剖切',
          val: 'AllClip',
          maxHeight: '45rem',
          minHeight: '6rem',
          iconName: 'icon-yxr-globalSection',
          unAllowCoexistCom: [],
          children: [
            {
              name: '全局剖切',
              val: 'AllClip',
              maxHeight: '45rem',
              minHeight: '6rem',
              iconName: 'icon-yxr-globalSection',
              unAllowCoexistCom: [],
            },
            {
              name: '局部剖切',
              val: 'PartClipBox',
              iconName: 'icon-yxr-partialSection',
              maxHeight: '45rem',
              minHeight: '6rem',
              unAllowCoexistCom: [],
            },
            {
              name: '三面剖切',
              val: 'ThreePanel',
              unAllowCoexistCom: [],
              maxHeight: '45rem',
              minHeight: '6rem',
              iconName: 'icon-yxr-cutThreeSides',
            },
          ],
        },
        {
          name: '第一人称漫游',
          val: 'system.walk.first',
          iconName: 'icon-yxr-firstPersonRoaming',
          unAllowCoexistCom: [],
          children: [
            {
              name: '第一人称漫游',
              val: 'system.walk.first',
              iconName: 'icon-yxr-firstPersonRoaming',
              unAllowCoexistCom: [],
            },
            {
              name: '第三人称漫游',
              val: 'system.walk.fixView',
              iconName: 'icon-yxr-thirdPersonRoaming',
              unAllowCoexistCom: [],
            },
          ],
        },
        {
          name: '两点测量',
          val: 'M_Line',
          iconName: 'icon-yxr-twoPointMeasurement',
          hoverWidth: 310,
          unAllowCoexistCom: [],
          children: [
            {
              name: '两点测量',
              val: 'M_Line',
              iconName: 'icon-yxr-twoPointMeasurement',
              unAllowCoexistCom: [],
            },
            {
              name: '多点测量',
              val: 'M_Point',
              iconName: 'icon-yxr-multipointMeasurement',
              unAllowCoexistCom: [],
            },
            {
              name: '高度测量',
              val: 'M_Vertical',
              iconName: 'icon-yxr-heightMeasurement',
              unAllowCoexistCom: [],
            },
            {
              name: '立体测量',
              val: 'M_Stereo',
              iconName: 'icon-yxr-stereometry',
              unAllowCoexistCom: [],
            },
            {
              name: '角度测量',
              val: 'M_Angel',
              iconName: 'icon-yxr-angleMeasurement',
              unAllowCoexistCom: [],
            },
            {
              name: '面积测量',
              val: 'M_Area',
              iconName: 'icon-yxr-areaMeasurement',
              unAllowCoexistCom: [],
            },
            {
              name: '轴距测量',
              val: 'M_WheelBase',
              iconName: 'icon-yxr-wheelbaseMeasurement',
              unAllowCoexistCom: [],
            },
            {
              name: '清除测量结果',
              val: 'M_None',
              iconName: 'icon-line-delete',
              unAllowCoexistCom: [],
            },
          ],
        },
        {
          name: '材质编辑',
          val: 'EditTexture',
          maxHeight: '45rem',
          minHeight: '45rem',
          iconName: 'icon-line-edit',
          unAllowCoexistCom: [],
          children: [
            {
              name: '材质编辑',
              val: 'EditTexture',
              maxHeight: '45rem',
              minHeight: '45rem',
              iconName: 'icon-line-edit',
              unAllowCoexistCom: [],
            },
            {
              name: '模型透明度',
              val: 'transparencySetting',
              maxHeight: '45rem',
              minHeight: '45rem',
              iconName: 'icon-bg-model',
              unAllowCoexistCom: [],
            },
          ],
        },
        {
          name: '偏好设置',
          val: 'PreferenceSetting',
          maxHeight: '50rem',
          minHeight: '35rem',
          iconName: 'fas fa-cogs',
          unAllowCoexistCom: [],
        },
        {
          name: '保存相机视角',
          val: 'saveCameraView',
          maxHeight: '50rem',
          minHeight: '35rem',
          iconName: 'fas fa-camera',
          unAllowCoexistCom: [],
        },
        {
          name: '批注',
          val: 'imgAnnotation',
          iconName: 'fas fa-map-marked-alt',
          maxHeight: '35rem',
          minHeight: '35rem',
          unAllowCoexistCom: [],
        },
        {
          name: '查看批注',
          val: 'viewImgAnnotation',
          iconName: 'far fa-images',
          maxHeight: '35rem',
          minHeight: '35rem',
          unAllowCoexistCom: [],
        },
        // {
        //   name: '偏好设置',
        //   val: 'PreferenceSetting',
        //   maxHeight: '43rem',
        //   minHeight: '35rem',
        //   iconName: 'icon-line-edit',
        //   unAllowCoexistCom: [],
        // },
      ],
      businessTabBar: [],
      // 业务功能按钮
      businessAllTabBar: [
        // {
        //   name: '电缆',
        //   val: 'CableList',
        //   iconName: 'icon-yxr-dl',
        //   maxHeight: '50rem',
        //   minHeight: '35rem',
        //   unAllowCoexistCom: [],
        // },
        // {
        //   name: '碰撞',
        //   val: 'clashList',
        //   iconName: 'icon-yxr-pz',
        //   maxHeight: '50rem',
        //   minHeight: '35rem',
        //   unAllowCoexistCom: [],
        // },
        // {
        //   name: '进度',
        //   val: 'ProcessRelational',
        //   iconName: 'icon-yxr-jd',
        //   maxHeight: '50rem',
        //   minHeight: '35rem',
        //   unAllowCoexistCom: [],
        // },
        // {
        //   name: '路径漫游',
        //   val: 'RoamPathList',
        //   iconName: 'icon-yxr-ldxs',
        //   maxHeight: '50rem',
        //   minHeight: '35rem',
        //   unAllowCoexistCom: [],
        // },
        {
          name: '点位设置',
          val: 'PointSetting',
          iconName: 'icon-yxr-zdxj',
          maxHeight: '50rem',
          minHeight: '35rem',
          unAllowCoexistCom: [],
        },
        // {
        //   name: '摄像头列表',
        //   val: 'MonitorList',
        //   iconName: 'icon-yxr-zbaf',
        //   maxHeight: '35rem',
        //   minHeight: '35rem',
        //   unAllowCoexistCom: [],
        // },
        // {
        //   name: '组态管理',
        //   val: 'ConfigureManage',
        //   iconName: 'icon-yxr-ztxs',
        //   maxHeight: '35rem',
        //   minHeight: '35rem',
        //   unAllowCoexistCom: [],
        // },
        {
          name: '设备信息',
          val: 'EquipmentInfo',
          iconName: 'icon-yxr-ysx',
          maxHeight: '35rem',
          minHeight: '35rem',
          unAllowCoexistCom: [],
        },
        {
          name: '标记列表',
          val: 'MarkerList',
          iconName: 'icon-yxr-zwj',
          maxHeight: '35rem',
          minHeight: '35rem',
          unAllowCoexistCom: [],
        },
        // {
        //   name: '三维标记',
        //   val: 'mark',
        //   iconName: 'icon-yxr-xjdh',
        //   maxHeight: '35rem',
        //   minHeight: '35rem',
        //   unAllowCoexistCom: [],
        // },
        {
          name: '电子围栏',
          val: 'FenceDataList',
          iconName: 'icon-yxr-wl',
          maxHeight: '35rem',
          minHeight: '35rem',
          unAllowCoexistCom: [],
        },
        {
          name: '关联测点信息',
          val: 'BindMeasurePoint',
          iconName: 'icon-yxr-glcd',
          maxHeight: '41rem',
          minHeight: '35rem',
          unAllowCoexistCom: [],
        },
        // {
        //   name: '测点历史数据',
        //   val: 'MeasurePoint',
        //   iconName: 'icon-yxr-bq',
        //   unAllowCoexistCom: [],
        // },
        // {
        //   name: '报警信息',
        //   val: 'AlarmInfo',
        //   iconName: 'icon-yxr-bj',
        //   unAllowCoexistCom: [],
        // },
        {
          name: '人员定位',
          val: 'PersonnalPosition',
          iconName: 'icon-yxr-bg-dw',
          maxHeight: '5rem',
          minHeight: '35rem',
          unAllowCoexistCom: [],
        },
        {
          name: '绘制电子围栏',
          val: 'FenceDraw',
          iconName: 'icon-yxr-hzwl',
          maxHeight: '50rem',
          minHeight: '35rem',
          unAllowCoexistCom: [],
        },
        {
          name: '门禁详细列表',
          val: 'AccessControlList',
          iconName: 'icon-yxr-mj',
          maxHeight: '35rem',
          minHeight: '35rem',
          unAllowCoexistCom: [],
        },
        {
          name: '安防详细列表',
          val: 'SecurityList',
          iconName: 'icon-yxr-zbaf',
          maxHeight: '35rem',
          minHeight: '35rem',
          unAllowCoexistCom: [],
        },
        {
          name: '新增模型',
          val: 'AddDeviceModel',
          iconName: 'icon-xzjd',
          maxHeight: '35rem',
          minHeight: '30rem',
          unAllowCoexistCom: [],
        },
        {
          name: '二次设备编辑',
          val: 'SecondaryDeviceEdit',
          iconName: 'icon-xzjg',
          maxHeight: '35rem',
          minHeight: '30rem',
          unAllowCoexistCom: [],
        },
        {
          name: '模型编辑工具',
          val: 'ModelEditTool',
          iconName: 'icon-bjjd',
          maxHeight: '18rem',
          minHeight: '18rem',
          unAllowCoexistCom: [],
        },
        {
          name: '卷册文档',
          val: 'VolumeDocuments',
          iconName: 'icon-open-folder',
          maxHeight: '50rem',
          minHeight: '35rem',
          unAllowCoexistCom: [],
        },
        {
          name: '数据监测',
          val: 'DataMonitoring',
          iconName: 'icon-yxr-xhjl',
          maxHeight: '48rem',
          minHeight: '35rem',
          unAllowCoexistCom: [],
        },
        {
          name: '实时数据',
          val: 'LedgerRelated',
          iconName: 'icon-yxr-sssj',
          maxHeight: '48rem',
          minHeight: '35rem',
          unAllowCoexistCom: [],
        },
        {
          name: '设备详情',
          val: 'DeviceDetail',
          iconName: 'icon-yxr-sbzt1',
          maxHeight: '48rem',
          minHeight: '35rem',
          unAllowCoexistCom: [],
        },
        {
          name: '显示流向',
          val: 'xslx',
          iconName: 'icon-yxr-xslx',
          maxHeight: '48rem',
          minHeight: '35rem',
          hoverWidth: 235,
          unAllowCoexistCom: [],
          children: [
            {
              name: '显示流向',
              val: 'xslx',
              iconName: 'icon-yxr-xslx',
              unAllowCoexistCom: [],
            },
            {
              name: '关闭流向',
              val: 'gblx',
              iconName: 'icon-yxr-gblx',
              unAllowCoexistCom: [],
            },
            {
              name: '全部显示',
              val: 'qbxs',
              iconName: 'icon-yxr-qbxs',
              unAllowCoexistCom: [],
            },
            {
              name: '全部关闭',
              val: 'qbgb',
              iconName: 'icon-yxr-qbgb',
              unAllowCoexistCom: [],
            },
            {
              name: '隐藏无流向',
              val: 'ycwlx',
              iconName: 'icon-yxr-ycwlx',
              unAllowCoexistCom: [],
            },
            {
              name: '显示无流向',
              val: 'xswlx',
              iconName: 'icon-yxr-xswlx',
              unAllowCoexistCom: [],
            },
          ],
        },
      ],
      fileDetailList: [], // 加载的模型 or 文件详细信息
      // 模型加载相关end
      mainPlayer: null, // 文件加载完成时player实例 主屏
      currentCode: '', // 当前点击的code
      mainFileType: '', // 主屏的文件类型
      splitFileType: '', // 分屏的文件类型
      // 文件加载相关 start
      fileSplitProps: {
        fileName: '',
        fileType: '',
        fileUrl: '',
        fileId: '',
      },
      fileMainProps: {
        fileName: '',
        fileType: '',
        fileUrl: '',
        fileId: '',
      },
      fileTypeList: ['svg', 'pdf', 'wizdrawing', 'png', 'jpg', 'gif', 'bmp', 'tif', 'mp4'], // 文件加载支持的类型
      // 文件加载相关 end
      bitRelationalData: {},
      spanRight: 0,
      spanLeft: 24,
      showCloseScreen: false, // 是否显示分屏
      anchorPos: [0, 0, 0],
      // 业务相关的
      showBusinessComponents: RoamPathList,
      showBusinessDialog: false,
      docModelCode: '', // 文档信息接收模型code
      bitModelCode: '', // 位号基本信息接收模型code
      currentDocumentId: '', // 当前的DocumentId
      currentModel: {}, // 当前选中的模型信息，或场景中默认加载的模型信息
      componentHeight: '',
      editToolHeight: '',
      showDocComponent: false,
      showBitComponent: false,
      showModelEditTool: false,
      codeChangeType: '', // code变化是由什么触发的
      docHeight: {
        minHeight: '30rem',
        maxHeight: '40rem',
        isZoom: false,
      },
      bitHeight: {
        minHeight: '26.5rem',
        maxHeight: '39.2rem',
        isZoom: false,
      },
      businessTabInfo: {
        selectBusinessList: [], // 选中的业务list
        currentDialog: {
          name: '',
          val: '',
          iconName: '',
          activeIconName: '',
        }, // 当前激活的弹框信息
      },
      openDialogList: [], // 已打开的业务弹框列表
      showDialogCom: [
        'RoamPathList',
        'CableList',
        'clashList',
        'ProcessRelational',
        'PointSetting',
        'MonitorList',
        'ConfigureManage',
        'MarkerList',
        'FenceDataList',
        'BindMeasurePoint',
        'PersonnalPosition',
        'FenceDraw',
        'AccessControlList',
        'SecurityList',
        'AddDeviceModel',
        'SecondaryDeviceEdit',
        'ModelEditTool',
        'VolumeDocuments',
        'DataMonitoring',
      ],
      // 无需打开弹框的组件
      unOpenDialog: ['MeasurePoint', 'LedgerRelated', 'AlarmInfo', 'EquipmentInfo', 'DeviceDetail'],
      showMeasurePoint: false,
      showDeviceDetail: false,
      showAlarmInfo: false,
      showEquipmentInfo: false,
      showPipeFlowDirection: false, // 是否显示管道流向组件
      showLedgerRelated: false, // 是否显示sis实时数据
      basicComponents: '', // 当前显示的基本弹框组件
      isShowWaitLayer: false,
      backgroundOffsetX: 0, // 顶部图片偏移量
      showPlayerSetting: false,
      showAccessControlList: false, // 门禁详细列表
      currentEngineerNode: {},
      currentCreateNode: null, // 新添加的模型节点
      watchNodeModifyTiming: {}, // 模型节点编辑监听
      modelRelationAccessList: [], // 模型所关联的门禁信息
      currentEditMoment: 0, // 每次执行节点编辑的时间
      allConvertNodeList: [], // 组态管理里面存的流向映射表
      tagId: '', // 位号id
      isTag: false, // 是否位号
      systemParams: localStorage.getItem('systemParams')
        ? JSON.parse(localStorage.getItem('systemParams'))
        : [],
      captureProps: {
        imgUrl: '',
      },
      showRotationSettings: false,
      flipHorizontal: false, // 水平翻转图像
      showAnnotationListDialog: false,
      isLoadingAnnotations: false, // 添加loading状态
      defaultCameraView: '',
    }
  },
  watch: {
    showCloseScreen(val) {
      if (val) {
        this.spanLeft = 12
        this.spanRight = 12
      } else {
        this.spanLeft = 24
        this.spanRight = 0
      }
    },
  },
  computed: {
    // 兼容除saas其他项目使用该模块
    basePath() {
      const routerBase = _.get(Wiz, 'globalSettings.globalConfig.routerBase')
      if (!routerBase) {
        return ''
        // eslint-disable-next-line no-else-return
      } else if (routerBase && Array.isArray(routerBase)) {
        return routerBase.length ? `/${routerBase[0]}` : ''
      }
      return `/${routerBase}`
    },
    // 获取项目信息
    currentProject() {
      return this.$store.getters.currentProject || {}
    },
    // 生成随机数
    randomId() {
      let Num = ''
      for (let i = 0; i < 6; i = i + 1) {
        Num += Math.floor(Math.random() * 10)
      }
      return Num
    },
    componentTop() {
      return this.bitHeight.isZoom ? `${parseInt(this.bitHeight.minHeight, 10) + 8}rem` : '6.6rem'
    },
    editToolTop() {
      return this.componentHeight ? `${parseInt(this.componentHeight, 10) + 8}rem` : '6.6rem'
    },
    // 获取是否需要广告牌
    ifAddBoard() {
      const obj = _.find(this.systemParams, { parameterCode: 'ifAddBoard' })
      return obj ? obj.parameterValue : false
    },
    standardId() {
      return this.$route.query.standardId
    },
    classId() {
      return this.$route.query.classId
    },
    isVersion() {
      return this.$route.query.isVersion
    },
  },
  methods: {
    annotationClick(val) {
      if (val === 'imgAnnotation') {
        this.showImageAnnotationComponent()
        this.closeAnnotationList()
      } else if (val === 'viewImgAnnotation') {
        this.showAnnotationList()
      } else if (val === 'saveCameraView') {
        this.saveCameraView()
      }
    },
    async getDefaultCameraView() {
      const codeAttrRes = await DocumentManagementService.getEntityPropertyList({
        class_id: this.$route.query.classId,
        keyword: 'code',
      })
      if (codeAttrRes && codeAttrRes.code === 0 && codeAttrRes.data && codeAttrRes.data.length) {
        const cameraRes = await DocumentManagementService.getDynamicPropertyData({
          classId: this.$route.query.classId,
          keywords: decodeURIComponent(this.$route.query.title),
          classAttributeId: codeAttrRes.data[0].id,
          operator: 6,
        })
        if (cameraRes && cameraRes.code === 0 && cameraRes.data && cameraRes.data.length) {
          const cameraAttrRes = await DocumentManagementService.getEntityPropertyList({
            class_id: this.$route.query.classId,
            keyword: 'DefaultCameraView',
          })
          if (
            cameraAttrRes &&
            cameraAttrRes.code === 0 &&
            cameraAttrRes.data &&
            cameraAttrRes.data.length > 0
          ) {
            const cameraAttr = cameraAttrRes.data[0]
            const key = `${cameraAttr.classTableName}.${cameraAttr.columnName}`
            this.defaultCameraView = cameraRes.data[0][key]
          }
        }
      }
    },
    async saveCameraView() {
      // 获取当前相机参数
      const currentCameraView = await this.mainPlayer.Native.Camera.currentParam()

      const cameraAttrRes = await DocumentManagementService.getEntityPropertyList({
        class_id: this.$route.query.classId,
        keyword: 'DefaultCameraView',
      })
      console.log(cameraAttrRes, 'cameraAttrRes')
      if (
        cameraAttrRes &&
        cameraAttrRes.code === 0 &&
        cameraAttrRes.data &&
        cameraAttrRes.data.length > 0
      ) {
        const cameraAttr = cameraAttrRes.data[0]
        const key = `${cameraAttr.classTableName}.${cameraAttr.columnName}`
        const documentRes = await DocumentManagementService.getDocumentDetailById({
          id: this.$route.query.documentId,
          standardId: this.$route.query.standardId,
        })
        console.log(documentRes, 'documentRes')
        if (documentRes && documentRes.code === 0 && documentRes.data) {
          const saveCameraViewRes = await DocumentManagementService.saveDynamicTableData({
            classId: this.$route.query.classId,
            dataId: this.$route.query.documentId,
            folderId: '',
            standardId: this.$route.query.standardId,
            value: {
              [key]: JSON.stringify(currentCameraView),
              [`${cameraAttr.classTableName}__Document.code`]: documentRes.data.code,
              [`${cameraAttr.classTableName}__Document.revision`]: documentRes.data.revision,
            }, // 保存相机参数
          })
          if (saveCameraViewRes && saveCameraViewRes.code === 0) {
            this.$message.success('保存相机视角成功')
          } else {
            this.$message.error('保存失败')
          }
        }
      }
    },
    showImageAnnotationComponent() {
      if (!this.mainPlayer) {
        this.$message.warning('请等待模型加载完成')
        return
      }
      const loading = this.$loading({
        lock: true,
        text: '正在初始化...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)',
      })
      const videoElement = this.mainPlayer.config.video

      if (!videoElement) {
        this.$message.warning('未找到视频元素')
        this.isShowWaitLayer = false
        return
      }

      this.getConvertToImage(videoElement, {
        rotate: this.rotationAngle,
        flipHorizontal: true, // 添加水平翻转
      })
        .then((imgUrl) => {
          this.captureProps.imgUrl = imgUrl
          this.showImageAnnotation = true
          loading.close()
          this.showAnnotationBtn = false
        })
        .catch((error) => {
          console.error('截图失败:', error)
          this.$message.error('截图失败')
          loading.close()
        })
    },
    updateModelNode(node) {
      if (!node) {
        console.error('updateModelNode: node is undefined')
        return
      }
      this.modelNodeHandler(node)
      // EventBus.$emit('updateModelNode', node)
    },
    async modelNodeHandler(val) {
      if (val?.code && val.id && window.svgData) {
        window.svgData[window.location.href].svgHotTrigger(val.code, val.id)
      } else if (val?.code && window.svgData) {
        this.modelNodeHandlerByCode(val)
      } else if (val?.code) {
        const res = await DocumentManagementService.getTagListByCodeOrName({
          keyword: val.code,
          standardId: this.standardId,
        })
        if (res && res.data && res.data.length > 0) {
          const data = res.data.find((e) => {
            return e.code === val.code
          })
          this.isTag = true
          this.setObjectNode({
            businessId: data.id,
            code: data.code,
          })
        }
      }
    },
    async modelNodeHandlerByCode(val) {
      if (val?.code) {
        const res = await DocumentManagementService.getTagListByCodeOrName({
          keyword: val.code,
          standardId: this.standardId,
        })
        if (res && res.data && res.data.length > 0) {
          let data = res.data.find((e) => {
            return e.code === val.code
          })
          if (val.businessId) {
            data = res.data.find((e) => {
              return e.id === val.businessId
            })
          }
          this.isTag = true
          this.bitModelCode = data.code
          this.currentCode = data.code
          this.setObjectNode({
            businessId: data.id,
            code: data.code,
          })
          window.svgData[window.location.href].svgHotTrigger(data.code, data.id)
        }
      }
    },
    setObjectNode(data) {
      if (this.$refs.docRelational) {
        console.log('setObjectNode Function', this.$refs.docRelational.$refs)
        if (this.$refs.docRelational.$refs.virtualTree != undefined) {
          this.$refs.docRelational.setCurrentNode(data.businessId)
          this.$refs.docRelational.$refs.virtualTree.setCurrentKey(data.businessId)
          // // 获取高亮节点的 DOM
          this.$nextTick(() => {
            const currentNode = this.$refs.docRelational.$refs.virtualTree.$el.querySelector(
              '.el-tree-node.is-current'
            )
            console.log(
              'setObjectNode Tree',
              currentNode,
              this.$refs.docRelational.$refs.virtualTree
            )
            if (currentNode) {
              currentNode.scrollIntoView({ block: 'center', behavior: 'smooth' })
            }
          })
        }
        // if(this.$refs.docRelational.$refs.realTableNode){
        //   // this.$refs.docRelational.$refs.realTableNode.setCurrentRow(data.businessId)
        //   this.$refs.docRelational.setCurrentTableRow(data.code)
        //   // // 获取高亮节点的 DOM
        //   this.$nextTick(()=>{
        //     const currentNode = this.$refs.docRelational.$refs.realTableNode.$el.querySelector('.el-table__row.current-row');
        //     console.log("setObjectNode Table", currentNode, this.$refs.docRelational.$refs.realTableNode)
        //     if (currentNode) {
        //       currentNode.scrollIntoView({ block: 'center', behavior: 'smooth' });
        //     }
        //   })
        // }
      }
    },
    // 模型节点编辑完成
    modifyNodeEnd(timing, node) {
      this.watchNodeModifyTiming = { timing, node }
    },
    // 获取广告牌后处理modelList
    async dealAddModelList(modelListCopy) {
      // 组装广告牌的数据
      const addList = await this.initAddData()
      if (addList) {
        const addModel = await this.getAddModelPlayId()
        _.forEach(modelListCopy, (val) => {
          // 获取所有匹配Id的广告牌
          _.forEach(addList, (value) => {
            if (value.documentFileId === val.fileId) {
              value.name = '广告牌'
              value.md5 = addModel.Md5
              value.fileId = addModel.FileId
              modelListCopy.push(value)
            }
          })
        })
      }
    },
    // 获取广告牌MD5
    async getAddModelPlayId() {
      const param = {
        siteId: this.currentProject.id || ' ',
        keywords: ' ',
        stageId: ' ',
        startTime: ' ',
        endTime: ' ',
      }
      const res = await this.apiModelCenter({
        method: 'list',
        params: param,
      })
      if (res && res.Success && res.Data) {
        const [models] = _.map(res.Data, (item) => {
          return item.Models
        })
        const addModel = _.find([models][0], (o) => {
          return o.Code === 'advertisementModel'
        })
        if (addModel) {
          return addModel
        }
      }
      return null
    },
    // 获取广告牌列表
    async initAddData() {
      const listRes = await addService.addManageList({
        pageNo: 1,
        pageSize: 9999,
        SiteId: this.currentProject.id,
      })
      if (listRes && listRes.data && listRes.code === 0) {
        return listRes.data
      }
      this.$message.error(listRes.message)
      return null
    },
    // 关闭模型设置页面
    closeSetting() {
      this.showPlayerSetting = false
    },
    // 点击设置按钮
    handlePlayerSetting() {
      if (this.showPlayerSetting) {
        this.$refs.playerSetting.closeSetting()
      } else {
        this.showPlayerSetting = true
      }
    },
    // 二三维标记截图部分功能
    hideMainEditView() {
      this.showMainEditPhoto = false
    },
    hideSplitEditView() {
      this.showSplitEditPhoto = false
    },
    /**
     * @description: 截图
     * @param {*} captureScreen 截图所在的屏
     * @return {*}
     */
    async captureImage(captureScreen, type) {
      let fileId
      if (captureScreen === 'pr') {
        captureScreen = type
        fileId = captureScreen === 'main' ? this.currentModel.fileId : this.modelSplitProps.fileId
      } else {
        fileId = captureScreen === 'main' ? this.fileMainProps.fileId : this.fileSplitProps.fileId
      }
      const fileType =
        captureScreen === 'main'
          ? this.mainFileType.toLowerCase()
          : this.splitFileType.toLowerCase()
      const markType = fileType === 'pr' ? 2 : 1
      if (fileType === 'pdf') {
        window.pdfCapture()
        window.addEventListener('message', (el) => {
          if (captureScreen === 'main') {
            this.MainEditViewProps = {
              imgUrl: el.data.imgBase,
              fileLocation: el.data.currentLocation,
              fileId,
              markType,
            }
            this.showMainEditPhoto = true
          } else {
            this.SplitEditViewProps = {
              imgUrl: el.data.imgBase,
              fileLocation: el.data.currentLocation,
              fileId,
              markType,
            }
            this.showSplitEditPhoto = true
          }
        })
      } else if (fileType === 'svg') {
        const status = await window.svgData[window.location.href].svgCapture()
        if (!status) {
          this.$message.warning('svg未加载完成,请稍候再试！')
          return
        }
        window.addEventListener('message', (el) => {
          if (el.data.type === 'svgCapture') {
            if (captureScreen === 'main') {
              this.MainEditViewProps = {
                imgUrl: el.data.imgBase,
                fileLocation: '',
                fileId,
                markType,
              }
              this.showMainEditPhoto = true
            } else {
              this.SplitEditViewProps = {
                imgUrl: el.data.imgBase,
                fileLocation: '',
                fileId,
                markType,
              }
              this.showSplitEditPhoto = true
            }
          }
        })
      } else if (fileType === 'pr' && captureScreen === 'main') {
        this.isShowWaitLayer = true // 开启等待图层
        const captureDom = this.mainPlayer.config.video
        const imgUrl = await this.getConvertToImage(captureDom, {
          rotate: this.rotationAngle,
          flipHorizontal: true,
        })
        const fileLocation = await PlayerUtils.call(
          this.mainPlayer.Native.CameraAnimation.cameraParam
        )
        if (captureScreen === 'main') {
          this.MainEditViewProps = {
            imgUrl,
            fileLocation,
            fileId,
            markType,
          }
          this.showMainEditPhoto = true
        } else {
          this.SplitEditViewProps = {
            imgUrl,
            fileLocation,
            fileId,
            markType,
          }
          this.showSplitEditPhoto = true
        }
      } else if (this.imgTypeList.includes(fileType)) {
        const captureDom = document.querySelector('#mainImgDom')
        const imgUrl = await this.getConvertToImage(captureDom)
        if (captureScreen === 'main') {
          this.MainEditViewProps = {
            imgUrl,
            fileLocation: '',
            fileId: this.mainFileId,
            markType,
          }
          this.showMainEditPhoto = true
        } else {
          this.SplitEditViewProps = {
            imgUrl,
            fileLocation: '',
            fileId,
            markType,
          }
          this.showMainEditPhoto = true
        }
      }
    },
    // 获取截图后的快照
    getConvertToImage(container, options = {}) {
      const width = parseInt(window.getComputedStyle(container).width, 10)
      const height = parseInt(window.getComputedStyle(container).height, 10)
      // html2canvas配置项
      const ops = {
        width,
        height,
        useCORS: true,
        allowTaint: false,
        ...options,
        dpi: 300,
      }
      return html2canvas(container, ops).then((canvas) => {
        this.isShowWaitLayer = false // 关闭等待图层

        // 如果需要旋转或翻转，创建新的canvas进行处理
        if (options.rotate) {
          const rotatedCanvas = document.createElement('canvas')
          rotatedCanvas.width = canvas.width
          rotatedCanvas.height = canvas.height
          const ctx = rotatedCanvas.getContext('2d')

          // 设置更好的图像渲染质量
          ctx.imageSmoothingEnabled = true
          ctx.imageSmoothingQuality = 'high'

          // 保存当前状态
          ctx.save()

          // 移动到画布中心
          ctx.translate(canvas.width / 2, canvas.height / 2)

          // 水平镜像翻转（沿Y轴翻转）
          if (options.flipHorizontal) {
            ctx.scale(-1, 1)
          }

          // 旋转
          if (options.rotate !== 0) {
            ctx.rotate((options.rotate * Math.PI) / 180)
          }

          // 绘制图像，注意调整原点位置
          ctx.drawImage(canvas, -canvas.width / 2, -canvas.height / 2, canvas.width, canvas.height)

          // 恢复状态
          ctx.restore()

          return rotatedCanvas.toDataURL('image/png')
        }

        return canvas.toDataURL('image/png')
      })
    },
    /**
     * @description: 展示标记
     * @param {*} node 标记信息
     * @return {*}
     */
    showMarker(nodes, type) {
      const node = nodes[0]
      if (type === 'split') {
        // 分屏过来的
        this.showSplitEditPhoto = true
        this.SplitEditViewProps = {
          imgUrl: this.currentEnv.VUE_APP_PLANT_SERVER + node.screenshotUrl,
          showMark: true,
          name: node.name,
          remark: node.remark,
          position: node.cameraPosition,
        }
      } else {
        this.showMainEditPhoto = true
        this.MainEditViewProps = {
          imgUrl: this.currentEnv.VUE_APP_PLANT_SERVER + node.screenshotUrl,
          showMark: true,
          name: node.name,
          remark: node.remark,
          position: node.cameraPosition,
        }
      }
    },
    sendBasicComponents(val) {
      this.basicComponents = val
    },
    /**
     * @description: 模型加载完成监听
     * @param {*}
     * @return {*}
     */

    LoadedAllModel() {
      this.loadedModel = true
      this.showAnnotationBtn = true
    },
    sendPlayer(player) {
      this.mainPlayer = player // 存储实例化完成的player
      initPlayer(player)
      this.mainPlayer.Native.Camera.EventAnchorPosChanged.connect(this.watchAnchorPos)
      if (this.currentEnv.VUE_APP_CURRENT_PROJECT === 'BC') {
        if (this.$route.query.documentId) {
          this.getModelRelationAccess([this.$route.query.documentId])
        } else if (this.$route.query.sceneId) {
          const documentIds = _.map(this.fileDetailList, 'documentId')
          this.getModelRelationAccess(documentIds)
        }
      }
    },
    // 获取模型文件所关联门禁信息
    async getModelRelationAccess(ids) {
      const res = await AccessControlSecurity.getRelationAccessByDocId({
        documentIds: ids,
      })
      if (res && res.code === 0 && res.data) {
        this.modelRelationAccessList = _.map(res.data, (item) => {
          return { ...item, doorState: 0 }
        })
        if (!_.isEmpty(this.modelRelationAccessList)) {
          this.getAccessState()
        }
      }
    },
    // 获取门禁实时状态
    async getAccessState() {
      const accessCodes = _.map(this.modelRelationAccessList, 'accessCode')
      const res = await AccessControlSecurity.getAccessState({
        doorIndexCodes: accessCodes,
      })
      if (res && res.code === 0 && res.data && res.data.data && res.data.data.authDoorList) {
        _.forEach(res.data.data.authDoorList, (item) => {
          const currentIndex = _.findIndex(this.modelRelationAccessList, [
            'accessCode',
            item.doorIndexCode,
          ])
          if (currentIndex !== -1) {
            this.modelRelationAccessList[currentIndex].doorState = item.doorState
          }
        })
        this.setAccessNodeColor()
      }
      setTimeout(() => {
        this.getAccessState()
      }, 3000)
    },
    // 设置门禁节点变色
    setAccessNodeColor() {
      const colorList = [0xffffffff, 0x00ff00ff, 0xff0000ff, 0x0000ffff]
      _.forEach(this.modelRelationAccessList, (item) => {
        if (item.doorState === 0) {
          this.mainPlayer.Native.ModelTree.restoreItemColor(item.tagCode)
        } else {
          this.mainPlayer.Native.ModelTree.setItemColor(item.tagCode, colorList[item.doorState])
        }
      })
    },
    // 监听锚点位置
    watchAnchorPos(pos) {
      this.anchorPos = _.map(pos, (item) => {
        return item.toFixed(2)
      })
    },
    /**
     * @description: 关联位号树的点击事件
     * @param {*} data
     * @return {*}
     */

    getModelData(data) {
      this.tagId = data.businessId
      this.isTag = data.isTag
      if (data.code) {
        this.modelNodeHandler(data)
        this.codeChangeType = 'docClick'
        this.bitModelCode = data.code
        this.currentCode = data.code
      }
    },

    setObjectNode(data) {
      if (this.$refs.docRelational) {
        console.log('setObjectNode Function', this.$refs.docRelational.$refs)
        if (this.$refs.docRelational.$refs.virtualTree != undefined) {
          this.$refs.docRelational.setCurrentNode(data.businessId)
          this.$refs.docRelational.$refs.virtualTree.setCurrentKey(data.businessId)
          // // 获取高亮节点的 DOM
          this.$nextTick(() => {
            const currentNode = this.$refs.docRelational.$refs.virtualTree.$el.querySelector(
              '.el-tree-node.is-current'
            )
            console.log(
              'setObjectNode Tree',
              currentNode,
              this.$refs.docRelational.$refs.virtualTree
            )
            if (currentNode) {
              currentNode.scrollIntoView({ block: 'center', behavior: 'smooth' })
            }
          })
        }
        // if(this.$refs.docRelational.$refs.realTableNode){
        //   // this.$refs.docRelational.$refs.realTableNode.setCurrentRow(data.businessId)
        //   this.$refs.docRelational.setCurrentTableRow(data.code)
        //   // // 获取高亮节点的 DOM
        //   this.$nextTick(()=>{
        //     const currentNode = this.$refs.docRelational.$refs.realTableNode.$el.querySelector('.el-table__row.current-row');
        //     console.log("setObjectNode Table", currentNode, this.$refs.docRelational.$refs.realTableNode)
        //     if (currentNode) {
        //       currentNode.scrollIntoView({ block: 'center', behavior: 'smooth' });
        //     }
        //   })
        // }
      }
    },
    /**
     * @description: 当前code变化
     * @param {*} code
     * @return {*}
     */

    currentCodeChange(code) {
      this.codeChangeType = 'other'
      this.currentCode = code
      this.currentDocumentId = this.currentModel.documentId
    },
    // 选中工程节点信息
    handleNodeClick(data) {
      this.currentEngineerNode = _.cloneDeep(data)
    },
    // 新增模型后更新树
    updateEditTree(node) {
      this.currentCreateNode = node
      // 每次执行操作后更新
      this.currentEditMoment = moment().valueOf()
    },
    /**
     * @description:分屏
     * @param {*} data
     * @return {*}
     */

    splitScreen(data) {
      this.splitFileType = data.type
      if (data.type === 'pr') {
        this.modelSplitList = [this.loadComponentByType(data)]
        this.currentSplitDocumentId = data.documentId
        this.modelSplitProps.defaultModelId = data.documentId
      } else {
        this.fileSplitProps = this.loadComponentByType(data)
      }
      this.showCloseScreen = true
    },
    /**
     * @description: 文件加载完时的回调事件
     * @param {*} val
     * @return {*}
     */

    loadFile() {},
    /**
     * @description: svg点击事件
     * @param {*} code
     * @return {*}
     */

    svgClick(code) {
      // code = 'T0BHE04B1-01'
      this.codeChangeType = 'svgClick'
      this.currentCode = code
      this.currentDocumentId = this.currentModel.documentId
      this.getInfoByCode(code)
    },
    /**
     * @description: 根据code取得位号的基本信息
     * @param {*} code
     * @return {*}
     */

    getInfoByCode(code) {
      this.docModelCode = `${code},${moment().valueOf()}`
      this.bitModelCode = code
    },
    /**
     * @description: 模型点选数据处理
     * @param {*} data
     * @param {*} type 触发的方法
     * @return {*}
     */

    async modelClick(data, type) {
      this.codeChangeType = type
      this.currentCode = data.code
      if (this.$route.query.engineerId) {
        const itemInfo = await this.mainPlayer.Native.ModelTree.getItemInfo(data.parentItem)
        const nodeInfo = await this.mainPlayer.Native.NodeProxy.getNodeInfo(itemInfo.nodePtr)
        this.currentEngineerNode = nodeInfo
        return
      }
      if (this.currentDocumentId !== data.documentId) {
        this.currentModel = _.find(this.fileDetailList, ['documentId', data.documentId])
        this.currentDocumentId = data.documentId
      }
      if (this.mainFileType === 'svg' || this.splitFileType === 'svg') {
        window.svgData[window.location.href].svgHotTrigger(data.code)
      }
      this.getInfoByCode(data.code)
    },
    /**
     * @description: 切换模型文件,移动相机至当前模型
     * @param {*} model 模型基本信息
     * @return {*}
     */

    async changeModelData(model) {
      if (this.$route.query.sceneId) {
        this.currentModel = _.find(this.fileDetailList, ['documentId', model.documentId])
        // 存储当前选中模型的基本信息
        this.docModelCode = ''
        this.currentDocumentId = model.documentId
      } else if (this.$route.query.engineerId) {
        // console.log(111111111)
      } else {
        this.currentModel = model
        const firstOpen = _.isEmpty(this.modelList)
        // 切换模型
        this.modelList = [this.loadComponentByType(model)]
        this.modelProps.defaultModelId = model.documentId
        this.currentDocumentId = model.documentId
        // 清除前一个模型的状态
        _.forEach(this.businessTabInfo.selectBusinessList, (item) => {
          this.removeTagsStatus(item)
        })
        this.businessTabInfo.selectBusinessList = []
        // 需要打开弹框的组件
        if (firstOpen && this.$route.query.type) {
          this.tagsBusinessClick([_.find(this.businessTabBar, ['val', this.$route.query.type])])
        }
      }
    },
    /**
     * @description: 获取文件详情
     * @param {*}
     * @return {*}
     */

    async getFileDetail(id) {
      const params = {
        id,
        standardId: this.standardId,
      }
      // 是否是历史版本预览
      if (this.isVersion === '1') {
        params.isVersion = true
        params.classId = this.classId
      }
      const res = await DocumentManagementService.getDocumentDetail(params)
      if (res && res.code === 0 && res.data) {
        let fileDetail = {}

        _.forEach(res.data.files, (file) => {
          if (res.data.documentBaseInfo.defaultFileId === file.fileIdOrigin) {
            fileDetail = file
          }
        })
        // 文件id
        fileDetail.fileId = res.data.documentBaseInfo.defaultFileId
        // 拼接模板属性
        fileDetail.attrObject = {}
        const templateAttr = _.find(this.systemParams, (item) => {
          return item.parameterCode === 'MultipleModelTemplate'
        })
        if (!_.isEmpty(res.data.templateAttrSetList) && templateAttr) {
          const attr = _.filter(res.data.templateAttrSetList, (el) => {
            return el.attributeTemplate.code === templateAttr.parameterValue
          })
          if (!_.isEmpty(attr)) {
            _.forEach(attr[0].attrValueList, (Attr) => {
              fileDetail.attrObject[Attr.fieldName] = Attr.attrValue
            })
          }
        }
        // 提取文件类型
        fileDetail.type = _.split(fileDetail.fileNameOrigin, '.')
          .pop()
          .toLowerCase()
        return fileDetail
      }
      return {}
    },
    /**
     * @description: 根据不同的文件类型加载不同的组件
     * @param {*} fileDetail 文件详情
     * @return {*}
     */

    loadComponentByType(fileDetail) {
      switch (fileDetail.type) {
        case 'pr':
          const query = fileDetail.attrObject || {
            Latitude: '',
            Longitude: '',
            Z_Axis_Angle: '',
            Y_Axis_Angle: '',
            Elevation: '',
            IsAutoFollowFloor: '',
            Model_Offset: 0,
            material: '',
          }
          return {
            ...query,
            documentId: fileDetail.documentId,
            md5: fileDetail.fileOriginMd5,
            name: fileDetail.fileNameOrigin,
            fileId: fileDetail.fileId,
            textureInfoId: fileDetail.textureInfoId,
            modelInfoId: fileDetail.modelInfoId,
            CameraPosition: this.defaultCameraView,
            // CameraPosition: fileDetail.attrObject ? fileDetail.attrObject.CameraPosition : '',
            // aniId: fileDetail?.aniId, // 动画文件id
            // aniName: fileDetail?.aniName, // 动画文件名称
            // aniMd5: fileDetail?.aniMd5, // 动画文件md5
          }
        case 'svg':
          return {
            id: `svgFrame+${this.randomId}`,
            fileName: fileDetail.fileName,
            fileType: fileDetail.type,
            fileUrl: `/lib/svgView/index.html?file=${this.currentEnv.VUE_APP_STANDARD_SERVER}/api/std/file/${fileDetail.fileId}`,
            fileId: fileDetail.fileId,
          }
        case 'pdf':
          return {
            id: `pdfFrame+${this.randomId}`,
            fileName: fileDetail.fileName,
            fileType: fileDetail.type,
            fileUrl: `/lib/pdfjs/web/viewer.html?file=${this.currentEnv.VUE_APP_STANDARD_SERVER}/api/std/file/${fileDetail.fileId}`,
            fileId: fileDetail.fileId,
          }
        case 'ht':
          return {}
        default:
          return {
            id: `defaultFrame+${this.randomId}`,
            fileName: fileDetail.fileName,
            fileType: fileDetail.type,
            fileUrl: `${this.currentEnv.VUE_APP_STANDARD_SERVER}/api/std/file/${fileDetail.fileId}`,
            fileId: fileDetail.fileId,
          }
      }
    },
    removeTagsStatus(removeTags) {
      if (this.showDialogCom.includes(removeTags)) {
        // 关闭弹框且判断弹框列表是否为空
        const removeTagIndex = _.findIndex(this.openDialogList, ['val', removeTags])
        if (removeTagIndex !== -1) {
          this.openDialogList.splice(removeTagIndex, 1)
        }
        if (!_.isEmpty(this.openDialogList) && removeTags !== 'ModelEditTool') {
          this.openBusinessDialog(_.last(this.openDialogList))
        } else if (removeTags === 'ModelEditTool') {
          this.showModelEditTool = false
          this.componentHeight =
            this.showBitComponent || this.showModelEditTool
              ? this.businessTabInfo.currentDialog.minHeight
              : this.businessTabInfo.currentDialog.maxHeight
        } else {
          // 清除弹框状态，菜单栏状态
          this.businessTabInfo.currentDialog = this.$options.data().businessTabInfo.currentDialog
          this.bitHeight = {
            minHeight: '30rem',
            maxHeight: '45rem',
            isZoom: false,
          }
          this.showBusinessDialog = false
          this.componentHeight = ''
        }
      } else if (this.unOpenDialog.includes(removeTags)) {
        // 关闭非弹框组件
        this.switchUnOpenDialog(removeTags, false)
      }
    },
    setTabBarStatus(tag) {
      let removeTags = []
      // 切换
      removeTags = _.remove(this.businessTabInfo.selectBusinessList, (item) => {
        return item === tag.val || tag.unAllowCoexistCom.includes(item)
      })
      _.forEach(removeTags, (item) => {
        this.removeTagsStatus(item)
      })
      // 数组变化子组件未监听到变化，所以重新赋值。
      this.businessTabInfo.selectBusinessList = _.clone(this.businessTabInfo.selectBusinessList)
      if (!removeTags.includes(tag.val)) {
        if (this.showBitComponent && tag.val === 'ModelEditTool') {
          return false
        }
        this.businessTabInfo.selectBusinessList.push(tag.val)
        return true
      }
      return false
    },
    /**
     * @description: 业务按钮点击事件
     * @param {*} arg 当前点击的按钮信息
     * @return {*}
     */

    tagsBusinessClick(arg, type) {
      const tag = arg[0]
      // 不需要激活态的节点
      const unActiveNode = ['mark', 'xslx', 'gblx', 'qbxs', 'qbgb', 'xswlx', 'ycwlx']
      if (!unActiveNode.includes(tag.val)) {
        // 判断当前tag是否在selectList中
        const changeActiveBusinessTag = this.setTabBarStatus(tag)
        if (!changeActiveBusinessTag) return
        // 业务弹框点击事件
        if (this.showDialogCom.includes(tag.val)) {
          // 执行弹框打开事件
          this.openBusinessDialog(tag)
        } else if (this.unOpenDialog.includes(tag.val)) {
          // 开启指定组件
          this.switchUnOpenDialog(tag.val, true)
        }
        // 区分弹框组件与非弹框组件
        // 弹框组件，开启or关闭
      }
      if (unActiveNode.includes(tag.val)) {
        if (tag.val === 'mark') {
          this.captureImage('pr', type)
        } else {
          // 开启指定组件
          this.switchUnOpenDialog(tag.val, true)
        }
      }
    },
    /**
     * @description: 执行非弹框组件
     * @param {*} val tag中的val
     * @param {*} isShow 是否显示组件
     * @return {*}
     */

    async switchUnOpenDialog(val, isShow) {
      switch (val) {
        // unOpenDialog数组中的值
        case 'MeasurePoint':
          this.showMeasurePoint = isShow
          break
        case 'LedgerRelated':
          this.$refs.LedgerRelated.visibleMarkers({
            visible: isShow,
            type: 'SSCS',
            tagCodes: '',
          })
          break
        case 'DeviceDetail':
          this.showDeviceDetail = isShow
          break
        case 'AlarmInfo':
          this.showAlarmInfo = isShow
          break
        case 'EquipmentInfo':
          this.showEquipmentInfo = isShow
          break
        case 'xslx':
        case 'gblx':
        case 'qbxs':
        case 'qbgb':
        case 'xswlx':
        case 'ycwlx':
          this.$refs.PipeFlowDirection.todoOperation(val)
          break
        default:
          break
      }
    },
    switchDialog(row) {
      if (row.val === this.businessTabInfo.currentDialog.val) {
        // 清除弹框状态，菜单栏状态
        this.businessTabInfo.currentDialog = this.$options.data().businessTabInfo.currentDialog
        this.showBusinessComponents = ''
        this.bitHeight = {
          minHeight: '30rem',
          maxHeight: '45rem',
          isZoom: false,
        }
        return
      }
      this.openBusinessDialog(row)
    },
    /**
     * @description: 需要打开弹框的组件
     * @param {*} data
     * @return {*}
     */

    openBusinessDialog(data) {
      if (data.val === 'ModelEditTool' && !this.showBitComponent) {
        this.showModelEditTool = true
        this.componentHeight = this.showBusinessDialog
          ? this.businessTabInfo.currentDialog.minHeight
          : ''
        return
      }
      // 开启弹框 or新增弹框
      if (
        _.isEmpty(_.find(this.openDialogList, ['val', data.val])) &&
        data.val !== 'ModelEditTool'
      ) {
        this.openDialogList.push({ ...data, expand: true })
      }
      if (data.val !== 'ModelEditTool') {
        this.businessTabInfo.currentDialog = data
        this.showBusinessDialog = true
        this.showBusinessComponents = data.val
      }

      this.componentHeight =
        this.showBitComponent || this.showModelEditTool
          ? this.businessTabInfo.currentDialog.minHeight
          : this.businessTabInfo.currentDialog.maxHeight
      if (this.showBitComponent) {
        const val = parseInt('50rem', 10) - parseInt(this.componentHeight, 10)
        this.bitHeight = {
          minHeight: `${val}rem`,
          maxHeight: `${val}rem`,
          isZoom: true,
        }
      }
      if (!this.showBusinessDialog) {
        this.bitHeight = {
          minHeight: '30rem',
          maxHeight: '45rem',
          isZoom: false,
        }
      }
    },
    /**
     * @description:关闭业务组件弹框时的回调
     * @param {*}
     * @return {*}
     */

    closeBusinessComponent(val) {
      const currentCom = _.find(this.businessTabBar, ['val', val])
      if (currentCom) {
        this.setTabBarStatus(currentCom)
      }
    },
    /**
     * @description:位号弹框高度需要根据是否显示组件弹框而定
     * @param {*} bol
     * @return {*}
     */

    showBit(bol) {
      if (bol && this.showModelEditTool) {
        this.showModelEditTool = false
        this.closeBusinessComponent('ModelEditTool')
      }
      this.showBitComponent = bol
      if (this.businessTabInfo.currentDialog) {
        this.componentHeight = this.showBitComponent
          ? this.businessTabInfo.currentDialog.minHeight
          : this.businessTabInfo.currentDialog.maxHeight
        if (this.showBitComponent && this.showBusinessDialog) {
          const val = parseInt('50rem', 10) - parseInt(this.componentHeight, 10)
          this.bitHeight = {
            minHeight: `${val}rem`,
            maxHeight: `${val}rem`,
            isZoom: true,
          }
        } else {
          this.bitHeight = {
            minHeight: '30rem',
            maxHeight: '45rem',
            isZoom: false,
          }
        }
      }
    },
    showDoc(bol) {
      this.showDocComponent = bol
    },
    /**
     * @description: 根据配置文件获取互斥策略
     * @param {*}
     * @return {*}
     */

    async getTabBarTactics() {
      // 根据系统参数设置底部工具栏
      const modelTool = _.find(this.systemParams, { parameterCode: 'modelTool' }) || {}
      const res = this.basePath
        ? docViewTabBarTactics
        : await $.ajax('/static/docViewTabBarTactics.json')
      if (res.basic && res.business) {
        this.basicTabBar = _.map(this.basicTabBar, (tab) => {
          if (tab.children) {
            tab.children = _.map(tab.children, (tabChild) => {
              return {
                ...tabChild,
                unAllowCoexistCom: res.basic[tabChild.val],
              }
            })
          }
          return {
            ...tab,
            unAllowCoexistCom: res.basic[tab.val] || [],
          }
        })
        this.businessAllTabBar = _.map(this.businessAllTabBar, (businessTab) => {
          if (businessTab.children) {
            businessTab.children = _.map(businessTab.children, (businessTabChild) => {
              return {
                ...businessTabChild,
                unAllowCoexistCom: res.business[businessTabChild.val] || [],
              }
            })
          }
          return {
            ...businessTab,
            unAllowCoexistCom: res.business[businessTab.val] || [],
          }
        })
        // if (this.modelProps && this.modelProps.sceneOpenType === 0) {
        //   this.basicTabBar = _.filter(this.basicTabBar, (el) => {
        //     return !res.notDisplayByOpenGis.includes(el.val)
        //   })
        //   this.businessAllTabBar = _.filter(this.businessAllTabBar, (el) => {
        //     return !res.notDisplayByOpenGis.includes(el.val)
        //   })
        // }
        if (!_.isEmpty(modelTool.parameterValue)) {
          const barList = modelTool.parameterValue.split(',')
          if (_.includes(barList, '显示流向')) {
            this.showPipeFlowDirection = true
          }
          if (_.includes(barList, '实时数据')) {
            this.showLedgerRelated = true
          }
          this.businessTabBar = _.filter(this.businessAllTabBar, (tag) => {
            return _.indexOf(barList, tag.name) !== -1
          })
        }
        if (this.$route.query.engineerId) {
          _.remove(this.businessTabBar, (tag) => {
            return tag.val === 'DataMonitoring' || tag.val === 'DeviceDetail'
          })
          _.remove(this.basicTabBar, (tag) => {
            return tag.val === 'ModelTree'
          })
          this.basicTabBar.push({
            name: '模型节点编辑',
            val: 'NodeEditTree',
            maxHeight: '35rem',
            minHeight: '35rem',
            iconName: 'icon-mxjd',
            unAllowCoexistCom: [],
          })
        }
      }
    },
    handleAnnotationSave(editedImageUrl) {
      console.log('editedImageUrl', editedImageUrl)
      // Save the edited image
      // this.$message.success('截图批注已保存')

      // // Ask user what they want to do with the image
      // this.$confirm('您想如何处理这张批注图片?', '批注完成', {
      //   confirmButtonText: '下载图片',
      //   cancelButtonText: '关闭',
      //   type: 'info',
      //   distinguishCancelAndClose: true,
      //   callback: (action) => {
      //     if (action === 'confirm') {
      //       // Download the image
      //       const link = document.createElement('a')
      //       link.href = editedImageUrl
      //       link.download = `annotation_${new Date().getTime()}.png`
      //       document.body.appendChild(link)
      //       link.click()
      //       document.body.removeChild(link)
      //     }

      //     // Close the annotation component in all cases
      //     this.showImageAnnotation = false
      //   },
      // })
    },
    handleAnnotationClose() {
      // Close the annotation component
      this.showImageAnnotation = false
      this.showAnnotationBtn = true
    },
    getUrlParam(url, name) {
      const reg = new RegExp(`(^|&)${name}=([^&]*)(&|$)`) // 构造一个含有目标参数的正则表达式对象
      const r = url.match(reg) // 匹配目标参数
      if (r != null) return unescape(r[2])
      return null // 返回参数值
    },
    async getAnnotationLists() {
      this.isLoadingAnnotations = true
      const self = this
      try {
        const currentStandardId = this.getUrlParam(
          decodeURIComponent(window.top.location.href),
          'standardId'
        )
        const fileName = localStorage.getItem('currentViewFileTitle')

        const res = await window.top.V8.FormEngine.GetTableData({
          FormEngineKey: 'diy_annotations_list',
          _Where: [
            {
              Name: 'FileName',
              Value: fileName,
              Type: 'Like',
            },
            {
              Name: 'DataStandard',
              Value: currentStandardId,
              Type: '=',
            },
          ],
          _PageSize: 999,
          _PageIndex: 1,
        })
        console.log(res, 'res-1122')
        if (res.Code === 1 && res.Data && res.Data.length > 0) {
          self.annotationLists = res.Data
          return true
        }
        return false
      } catch (error) {
        console.error('获取批注列表失败:', error)
        this.$message.error('获取批注列表失败')
        return false
      } finally {
        this.isLoadingAnnotations = false
      }
    },
    async showAnnotationList() {
      const loading = this.$loading({
        lock: true,
        text: '正在加载批注列表...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)',
      })
      const hasData = await this.getAnnotationLists()
      loading.close()
      if (hasData) {
        this.showAnnotationListDialog = true
      } else {
        this.$message.info('暂无批注记录')
      }
    },
    closeAnnotationList() {
      this.showAnnotationListDialog = false
      this.annotationLists = []
    },
    handleDeleteAnnotation(item) {
      if (!item || !item.Id) {
        this.$message.error('无效的批注数据')
        return
      }

      this.$confirm('确认删除该批注？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          // 显示加载状态
          const loading = this.$loading({
            lock: true,
            text: '正在删除...',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)',
          })

          // 调用删除API
          return new Promise((resolve, reject) => {
            window.top.V8.DelDiyTableRow(
              {
                TableName: 'diy_annotations_list',
                Id: item.Id,
              },
              (result) => {
                if (result.Code === 1) {
                  resolve(result)
                } else {
                  reject(new Error(result.Msg || '删除失败'))
                }
              }
            )
          })
            .then(() => {
              // 删除成功后更新本地数据
              this.annotationLists = this.annotationLists.filter((annotation) => {
                return annotation.Id !== item.Id
              })
              loading.close()
              this.$message.success('删除成功')
            })
            .catch((error) => {
              loading.close()
              this.$message.error(error.message || '删除失败')
              console.error('删除批注失败:', error)
            })
        })
        .catch(() => {
          // 用户取消删除，不做任何操作
        })
    },
  },
  async created() {
    console.log(this.$route, 'this.$route')
    const token = Wiz.AuthHooks.GetToken()
    axios.defaults.headers.common.Authorization = `Bearer ${token}`
    this.currentCode = this.$route.query.code
    // 根据系统参数设置底部工具栏
    // const modelTool = _.find(this.systemParams, { parameterCode: 'modelTool' }) || {}
    this.fileDetailList = []
    // 从模型中心过来
    if (this.$route.query.documentId) {
      await this.getDefaultCameraView()
      // 获取file详情
      this.fileDetailList.push(await this.getFileDetail(this.$route.query.documentId))
      // this.modelProps.defaultModelId = this.fileDetailList[0].documentId
      this.modelProps.defaultModelId = this.$route.query.documentId
      this.currentDocumentId = this.$route.query.documentId
    } else if (this.$route.query.sceneId) {
      // 场景
      // 根据场景获取documentIdList
      const res = await SceneCenter.getSceneDetail({ id: this.$route.query.sceneId })
      if (res && res.code === 0 && res.data) {
        for (let i = 0; i < res.data.models.length; i = i + 1) {
          const model = res.data.models[i]
          this.fileDetailList.push({
            ...(await this.getFileDetail(model.modelDocumentId)),
            aniId: model.aniId,
            aniName: model.aniName,
            aniMd5: model.aniMd5,
          })
        }
        this.modelProps = {
          defaultModelId: res.data.defaultModelId || res.data.models[0].modelDocumentId,
          sceneOpenType: res.data.sceneOpenType,
        }
      }
    } else {
      // 未传入documentId or sceneId 则默认加载模型组件
      this.mainFileType = 'pr'
      // 获取底部工具栏的互斥策略, 根据加载的场景不同，显示不同的tabBar
      await this.getTabBarTactics()
      // 需要打开弹框的组件
      if (this.$route.query.type && this.$route.query.documentId) {
        this.tagsBusinessClick([_.find(this.businessTabBar, ['val', this.$route.query.type])])
      }
      return
    }
    // 获取底部工具栏的互斥策略, 根据加载的场景不同，显示不同的tabBar
    await this.getTabBarTactics()
    // 需要打开弹框的组件
    if (this.$route.query.type && this.$route.query.documentId) {
      this.tagsBusinessClick([_.find(this.businessTabBar, ['val', this.$route.query.type])])
    }
    this.currentModel = this.modelProps.defaultModelId
      ? _.find(this.fileDetailList, ['documentId', this.modelProps.defaultModelId])
      : this.fileDetailList[0]
    this.currentDocumentId = this.modelProps.defaultModelId
    this.mainFileType = this.currentModel.type
    // 添加材质ID
    this.currentModel.textureInfoId = this.$route.query.textureInfoId
    // 添加模型ID
    this.currentModel.modelInfoId = this.$route.query.modelInfoId
    // 根据不同的文件类型加载不同的组件
    const modelListCopy = []
    if (this.mainFileType === 'pr') {
      this.modelList = []
      _.forEach(this.fileDetailList, (file) => {
        modelListCopy.push(this.loadComponentByType(file))
      })

      if (this.ifAddBoard) {
        await this.dealAddModelList(modelListCopy)
      }
      this.modelList = _.cloneDeep(modelListCopy)
      console.log(this.modelList, 'modelList')
    } else {
      this.fileMainProps = this.loadComponentByType(this.fileDetailList[0])
    }
  },
}
</script>
<style lang="scss" scoped>

.image-annotation-btn {
  top: 591px;
  background: rgba(0, 0, 0, 0.25);
  border-radius: 0;
  width: 50px;
  height: 50px !important;
  right: 0;
  line-height: 58px;
  i {
    font-size: 28px;
  }
}
.image-annotation-view-btn {
  top: 641px;
  background: rgba(0, 0, 0, 0.25);
  border-radius: 0;
  width: 50px;
  height: 50px !important;
  right: 0;
  line-height: 58px;
  i {
    font-size: 28px;
  }
}
.split_icon {
  bottom: 3px;
  right: 10px;
}
.model-top {
  top: 0;
  height: 65px;
  flex-direction: row;
  background-color: transparent;
  font-weight: bold;
  z-index: 100;
  .anchor-pos {
    font-weight: normal;
    top: 2px;
    left: 0;
  }
  .top-mid,
  .top-left,
  .top-right {
    height: 100%;
    background-repeat: no-repeat;
    background-size: auto;
  }
  .top-parent-left,
  .top-parent-right {
    width: calc(50% - 250px);
    overflow: hidden;
  }
  .top-left {
    width: calc(100% + 260px);
    background-position: right;
    background-image: url('../../assets/images/left.png');
  }
  .top-mid {
    width: 500px;
    text-align: center;
    background-position: center;
    background-image: url('../../assets/images/mid.png');
  }
  .top-right {
    width: calc(100% + 260px);
    background-position: left;
    background-image: url('../../assets/images/right.png');
  }
}
.setting-model {
  height: 28px;
  i {
    background-image: linear-gradient(top, #ffffff, #99adcc);
    background-clip: text;
    -webkit-text-fill-color: transparent;
    z-index: 9999999;
  }
}
.model-top-font,
.anchor-pos {
  background-image: linear-gradient(top, #ffffff, #99adcc);
  background-clip: text;
  -webkit-text-fill-color: transparent;
}
.model-top-font {
  max-width: 1052px;
  top: 10px;
  z-index: 999;
  text-align: center;
}
.wait_layer {
  position: absolute;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 2002;
  top: 0px;
}
.position-relative {
  position: relative;
}
.position-absolute {
  position: absolute;
}
.flex-row-end {
  justify-content: flex-end;
}
.flex-row-center {
  display: flex;
  justify-content: center;
  align-items: center;
}
.loading-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  color: #fff;
}
.loading-container i {
  font-size: 32px;
  margin-bottom: 10px;
}
.rotation-settings-dialog {
  .el-dialog__body {
    padding: 20px;
  }
  .rotation-options {
    display: flex;
    flex-direction: column;
    gap: 10px;
  }
  .mb-10 {
    margin-bottom: 10px;
  }
  .flip-option {
    margin-top: 20px;
  }
}
.annotation-list-dialog {
  .annotation-list {
    max-height: 600px;
    overflow-y: auto;

    .annotation-items {
      display: flex;
      flex-direction: column;
      gap: 20px;
    }

    .annotation-item {
      border: 1px solid #ebeef5;
      border-radius: 4px;
      padding: 15px;
      background: #fff;
      box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);

      .annotation-header {
        display: flex;
        justify-content: space-between;
        align-items: center;

        .annotation-title {
          font-size: 16px;
          font-weight: 500;
          color: #303133;
          text-align: center;
        }

        .annotation-time {
          font-size: 14px;
          color: #909399;
        }
      }

      .annotation-content {
        display: flex;
        justify-content: center;

        .annotation-image {
          max-width: 100%;
          max-height: 400px;
          object-fit: contain;
        }
      }
    }
  }
}
.annotation-list-panel {
  position: fixed;
  top: 0;
  right: 0;
  width: 400px;
  height: 100%;
  background: #fff;
  box-shadow: -2px 0 8px rgba(0, 0, 0, 0.15);
  z-index: 1000;
  display: flex;
  flex-direction: column;

  .annotation-list-header {
    height: 50px;
    padding: 0 20px;
    border-bottom: 1px solid #ebeef5;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .title {
      font-size: 16px;
      font-weight: 500;
      color: #303133;
    }

    .close-icon {
      font-size: 20px;
      color: #909399;
      cursor: pointer;

      &:hover {
        color: #409eff;
      }
    }
  }

  .annotation-list {
    flex: 1;
    overflow-y: auto;
    padding: 20px;

    .annotation-items {
      display: flex;
      flex-direction: column;
      gap: 20px;
    }

    .annotation-item {
      border: 1px solid #ebeef5;
      border-radius: 4px;
      padding: 15px;
      background: #fff;
      box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);

      .annotation-header {
        margin-bottom: 10px;

        .annotation-title {
          font-size: 14px;
          font-weight: 500;
          color: #303133;
        }
      }

      .annotation-content {
        display: flex;
        justify-content: center;

        .annotation-image {
          width: 100%;
          max-height: 300px;
          object-fit: contain;
        }

        .image-loading,
        .image-error {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          width: 100%;
          height: 200px;
          background-color: #f5f7fa;
          color: #909399;

          i {
            font-size: 28px;
            margin-bottom: 8px;
          }

          p {
            margin: 0;
            font-size: 14px;
          }
        }

        .image-error {
          cursor: default;
          &:hover {
            color: #409eff;
          }
        }
      }
    }
  }
}
.annotation-content {
  position: relative;

  .delete-annotation-btn {
    position: absolute;
    top: 8px;
    right: 8px;
    z-index: 10;
    width: 24px;
    height: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: rgba(255, 77, 79, 0.8);
    border-radius: 50%;
    cursor: pointer;
    transition: all 0.3s;

    &:hover {
      background-color: #ff4d4f;
      transform: scale(1.1);
    }

    i {
      color: #fff;
      font-size: 14px;
    }
  }
}

</style>
